import UpgradeAccountError from './UpgradeAccountError';
class InvalidInvestorId extends UpgradeAccountError {
    constructor(options) {
        super('Investor id is invalid', options);
    }
}
export default InvalidInvestorId;
